module.exports = __webpack_public_path__ + "static/img/dribbble.9bac7b4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/external-profiles/dribbble.png
// module id = zmmP
// module chunks = 7